import {Poi, RouteEffect} from '../../../react-app-env';
import React from 'react';
import SidebarHeader, {buildPopStackButton} from '../../sidebar/SidebarHeader';
import {SidebarPage} from '../../sidebar/SidebarPage';
import {StackApi} from '../../stack/Stack.types';
import ListView from '../../listview/ListView';
import ListViewItem from '../../listview/listviewitem/ListViewItem';
import {i18n, RouteEffectI18n} from '../../../i18n/i18n';
import ListViewGroup from '../../listview/listviewgroup/ListViewGroup';
import './RouteEffectSidebarPage.scss';
import {IconSizes} from '../../icon/Icon';
import SidebarScrollableContent from '../../sidebar/SidebarScrollableContent';
import {ListViewItemDecoration, ListViewItemDecorationIcon} from '../../listview/listviewitem/ListViewItem.types';

export interface RouteEffectSidebarPageProps {
  poi: Poi;
  stackApi: StackApi;
}

const RouteEffectSidebarPage: React.FunctionComponent<RouteEffectSidebarPageProps> = ({ poi, stackApi }) => {

  const buildRouteEffectItem = (effect: RouteEffect, effectI18n: RouteEffectI18n) => {
    const decoration: ListViewItemDecoration = {
      icon: poi.routeEffect === effect ? ListViewItemDecorationIcon.OPTION_SELECTED : ListViewItemDecorationIcon.OPTION_EMPTY,
      size: IconSizes.MEDIUM
    };

    return <ListViewItem
        decoration={decoration}
        title={<div>
          <div className="route-effect__label">{effectI18n.label}</div>
          <div className="route-effect__description">{effectI18n.description}</div>
        </div>}
        onClick={() => {
        }}
    />;
  };

  return <SidebarPage className="route-effect">
    <SidebarHeader
        title={i18n().poiDetails.routeEffect.title}
        subtitle={poi.title}
        buttons={[
          buildPopStackButton(() => stackApi.pop())
        ]}/>
    <SidebarScrollableContent>
      <ListView>
        <ListViewGroup>
          {buildRouteEffectItem('NONE', i18n().routeEffects.none)}
          {buildRouteEffectItem('CONTINUE', i18n().routeEffects.continue)}
          {buildRouteEffectItem('RESTART', i18n().routeEffects.restart)}
        </ListViewGroup>
      </ListView>
    </SidebarScrollableContent>
  </SidebarPage>;
};

export default RouteEffectSidebarPage;
